export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_ERROR = "FETCH_NOTIFICATIONS_ERROR";

export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";
export const MARK_NOTIFICATIONS_READ_SUCCESS = "MARK_NOTIFICATIONS_READ_SUCCESS";
export const MARK_NOTIFICATIONS_READ_ERROR = "MARK_NOTIFICATIONS_READ_ERROR";

export const RECEIVED_NOTIFICATION = "RECEIVED_NOTIFICATION";
